<button class="close-button" mat-icon-button [mat-dialog-close]="false">
  <mat-icon>close</mat-icon>
</button>

<form [formGroup]="formGroup">
  <h1 mat-dialog-title>{{ "change-password" | translate }}</h1>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>{{ "old-password" | translate }}</mat-label>
      <input type="password" required matInput formControlName="oldPassword" />
      <mat-icon matPrefix>vpn_key</mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "new-password" | translate }}</mat-label>
      <input type="password" required matInput formControlName="newPassword" />
      <mat-icon matPrefix>vpn_key</mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "confirm-password" | translate }}</mat-label>
      <input type="password" required matInput formControlName="confirmPassword" />
      <mat-icon matPrefix>vpn_key</mat-icon>
      <mat-error>New password and confirm not match</mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button class="full-width" mat-raised-button color="primary" [disabled]="!isValid" (click)="changePassword()"
      cdkFocusInitial>
      {{ "change" | translate }}
    </button>
  </div>
</form>